import { jQueryLikeParamSerializer } from '../utils.js';

const ENDPOINT = 'POSTalbumSong';
function postAlbumSong(gateway, params) {
    return gateway.post(postAlbumSong.endpoint, {}, jQueryLikeParamSerializer(params), null, null, 'encrypted');
}
postAlbumSong.endpoint = ENDPOINT;

export { postAlbumSong as default };
//# sourceMappingURL=postAlbumSong.js.map
